import styled from 'styled-components';
import { colors, breakPoints } from '@/styles';

export const PdfFileView = styled.div`
  display: flex;
  flex-direction: column;
  & > div:first-child {
    border: 1px solid ${colors.secondary.lightGray3};
    border-radius: 5px;
    overflow: hidden;
  }
  /* align-items: center; */
  gap: 40px;
`;

export const PdfDisplay = styled.div`
  /* border: 1px solid lime; */
  display: flex;
  justify-content: center;
  background: ${colors.secondary.lightGray1};
  gap: 0px;
  & > div {
    /* border: 1px solid orange; */
  }
`;

export const Thumbnails = styled.div`
  flex: 0;
  position: relative;
  min-width: 140px;
  border-right: 1px solid ${colors.secondary.lightGray3};
  & > div {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    flex-direction: column;
    gap: 10px;
    width: 100%;
    /* max-height: 100%; */
    /* max-height: 100vh; */
    overflow-y: scroll;
    padding: 20px;
    /* padding-right: 30px; */
    background-color: ${colors.secondary.lightGray2};
  }
`;

export const PdfPage = styled.div`
  flex: 1;
  display: flex;
  justify-content: center;
  position: relative;
  padding: 20px;
  canvas {
    border: 1px solid ${colors.secondary.lightGray2};
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  }
`;

export const Thumbnail = styled.div<{ $selected?: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 5px;
  canvas {
    border: ${(props) =>
      props.$selected ? `1px solid ${colors.semantic.link}` : `1px solid ${colors.secondary.lightGray2}`};
  }
`;
